import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable,
         FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'show-event',
  templateUrl: './show-event.component.html',
  styleUrls: ['./show-event.component.scss'],
  animations: [slide]
})
export class ShowEventComponent implements OnInit {
  eventObservable: FirebaseObjectObservable<any>;
  galleryObservable: FirebaseListObservable<any>;

  event: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;
  showDeletePhotoModal = false;

  selectedPhoto;

  zoomView = false;
  zoomViewEventKey = null;
  zoomViewFileKey = null;
  uploadingPhoto = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService
  ) { }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.eventObservable = this.dbService.getEvent(params['key']);
      this.galleryObservable = this.dbService.getEventGallery(params['key']);
      this.eventObservable.subscribe(event => {
        this.event = event;
      });
    });
  }

  onEditClicked() {
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked() {
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onConfirmDeletePost() {
    this.onHideDeleteModal()
    this.dbService.deleteEvent(this.event.$key);
    this.router.navigate([`/calendar`]);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

  galleryFull() {
    this.event && this.event.gallery && Object.keys(this.event.gallery).length >= 12
  }

  onPhotoUpload(event) {
    this.uploadingPhoto = true;
    let file = event.target.files[0];
    /*let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.previewImg.nativeElement.src = reader.result;
    });

    reader.readAsDataURL(file);*/
    this.dbService.addToEventGallery(this.event, file)
                  .then( d => {
      this.uploadingPhoto = false;
    });

  }

  zoomPhoto(photo) {
    this.showModalBg = true;
    this.zoomView = true;
    this.zoomViewEventKey = this.event.$key;
    this.zoomViewFileKey = photo.$key;
  }

  closeZoomView() {
    this.showModalBg = false;
    this.zoomView = false;
    this.zoomViewEventKey = null;
    this.zoomViewFileKey = null;
  }

  deletePhoto(photo) {
    this.showModalBg = true;
    this.showDeletePhotoModal = true;
    this.selectedPhoto = photo;
  }

  onHideDeletePhotoModal() {
    this.selectedPhoto = null;
    this.showModalBg = false;
    this.showDeletePhotoModal = false;
  }

  onConfirmDeletePhoto() {
    this.dbService.removeEventGalleryPhoto(this.event, this.selectedPhoto.$key);
    this.onHideDeletePhotoModal();
  }

}



// WEBPACK FOOTER //
// ./src/app/calendar/show-event/show-event.component.ts